module.exports = __webpack_public_path__ + "assets/img/f8a56b7d642fc255fad76db37efa9afa.png";